import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const RoomSkeleton = () => {
  return (
    <Box
      width="full"
      height="full"
      position="relative"
      alignItems="center"
      border={{
        top: {
          width: 's1',
          style: 'solid',
          color: 'grey200',
        },
      }}
    >
      <Box width="full" height="full" position="relative" flexDirection="row">
        <Box width="full" height="full" paddingX="s24" gap="s4">
          <Box
            paddingY="s16"
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            width="full"
          >
            <Box width="s240">
              <Skeleton isLoading height="s32" />
            </Box>
            <Box flexDirection="row" gap="s8" alignItems="center" width="s200">
              <Skeleton isLoading height="s24" />
              <Skeleton isLoading height="s32" />
            </Box>
          </Box>
          <Skeleton isLoading height="full" />
          <Box width="full" alignItems="center">
            <Box
              style={{ width: '450px' }}
              position="relative"
              gap="s4"
              paddingY="s16"
              flexDirection="row"
            >
              <Skeleton isLoading height="s40" />
              <Skeleton isLoading height="s40" />
              <Skeleton isLoading height="s40" />
              <Skeleton isLoading height="s40" />
              <Skeleton isLoading height="s40" />
              <Skeleton isLoading height="s40" />
              <Skeleton isLoading height="s40" />
            </Box>
          </Box>
        </Box>
        <Box style={{ width: '612px' }} flexNoShrink paddingY="s12" paddingRight="s12">
          <Skeleton height="full" isLoading />
        </Box>
      </Box>
    </Box>
  )
}
